<div class="drawing-canvas-wrapper">
  <canvas #drawingCanvas width="1920" height="1080" style="border:1px solid #ccc; width:100%; max-width:100%; height:auto;"></canvas>
</div>
